//@ts-nocheck
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HeapAnalyticsService } from './heap-analytics.service';
import { HEAP_ANALYTICS_CONFIG, HeapAnalyticsConfig } from './heap-analytics-config';

function initializeHeap(heapAnalyticsService: HeapAnalyticsService): () => Observable<any> {
	return () =>
		of(null).pipe(
			tap(() => {
				heapAnalyticsService.load();
			}),
		);
}

@NgModule({
	declarations: [],
	imports: [CommonModule],
})
export class HeapAnalyticsModule {
	static forRoot(config: HeapAnalyticsConfig): ModuleWithProviders<HeapAnalyticsModule> {
		return {
			ngModule: HeapAnalyticsModule,
			providers: [
				HeapAnalyticsService,
				{ provide: HEAP_ANALYTICS_CONFIG, useValue: { appId: config.appId } },
				provideAppInitializer(() => {
					const initializerFn = initializeHeap(inject(HeapAnalyticsService));
					return initializerFn();
				}),
			],
		};
	}
}
